<div class="area-lista-contato">
  <span class="titulo">Lista de Contatos</span>

  <div class="lista-contato">
    @for (contato of listaContatos; track contato.telefone) {
      <div class="contato">
        <div class="flex-direction-row gap-10 align-center">
            <div [matTooltip]="toolTipFotoContato(contato)">
              <img width="40px" height="40px"  [src]="verificarFotoContato(contato)" [alt]="contato.nomeContato ?? 'Contato'"/>
            </div>

          <div class="flex-direction-column gap-5">
            <span class="weight-600 font-10">{{ contato.nomeContato }}</span>
            <span class="font-10">{{ contato.telefone | celularMask }}</span>
          </div>
        </div>

        <div class="flex-direction-column gap-5 justify-end">
          @if (contato.status === 'SENT') {
            <mat-icon style="font-size: clamp(16px, 1.3vw, 18px); width: clamp(16px, 1.3vw, 18px); height: clamp(16px, 1.3vw, 18px)">check</mat-icon>
          } @else if (contato.status === 'READ'){
            <img src="assets/icones/msgLida.svg" alt="Mensagem lida">
          }

          <span class="font-10">{{ contato.email }}</span>
        </div>
      </div>
    }
  </div>

  <app-button-padrao width="100%" label="Sair" backgroundColor="white" color="var(--vermelho-padrao)" (buttonClick)="sair()"
                     borderColor="var(--vermelho-padrao)" borderStyle="solid" borderWidth="1px"></app-button-padrao>
</div>
